<template>
	 <div class="form-group add-task">
      
      <button
	  	v-if ="!isFormShow"
      	type="button" class="btn btn-sm btn-primary btn-block"
		@click = "handleAddTask"
		
      >Add Task</button>

      <button
		v-else
       	type="button" class="btn btn-sm btn-success btn-block"
		@click = "handleAddTask"
		
      >Close Form</button>
    </div>
    
</template>
<script type="text/javascript">
	export default {
		name: "component-form-add",

		props: {
			isFormShow: {
				type: Boolean,
				default: false				
			}
		},

		data: function(){
			return {

			}
		},

		methods: {
			handleAddTask: function(){

				console.log("Click on ComponentFormAdd");

				this.$emit("handleAddTaskApp");
			},
			
		}
	}
</script>
<style type="text/css">
	button.btn.btn-sm.btn-success.btn-block {
    box-shadow: rgba(101, 41, 255, 0.15) 0px 10px 20px;
    color: white;
    font-weight: 600;
    /* cursor: pointer; */
    display: inline-block;
    justify-self: center;
    white-space: nowrap;
    background: linear-gradient(104.74deg, rgb(49, 17, 105) 0%, rgb(176, 30, 255) 100%);
    /* border-radius: 30px; */
    border-width: initial;
    border-style: none;
    border-color: initial;
    border-image: initial;
    /* padding: 16px 60px; */
    outline: none;
    transition: all 0.8s cubic-bezier(0.2, 0.8, 0.2, 1.2) 0s;
}
</style>